import * as React from "react";
import { Divider, Typography } from "antd";
import { IFormSectionPresentationModel } from "../../../presenter/form/model/FormSectionPresentationModel";
import DisplayFormSection from "../../components/form/DisplayFormSection";
import { IFormVersion } from "../../../model/form/FormVersion";
import { DateService } from "../../../service/DateService";
import Text from "antd/lib/typography/Text";

const HEIGHT_FORM_VERSION = window.innerHeight * 0.65;

const ComparisonFormVersions = ({
  translate,
  firstComparisonFormVersion,
  secondComparisonFormVersion,
  formVersionList,
  selectedVersions
}: {
  translate: any;
  firstComparisonFormVersion?: IFormSectionPresentationModel[];
  secondComparisonFormVersion?: IFormSectionPresentationModel[];
  formVersionList: IFormVersion[];
  selectedVersions: number[];
}) => {
  const renderFormSections = (
    formSectionList: IFormSectionPresentationModel[]
  ) => {
    let formSectionRenderList: JSX.Element[] = [];
    if (formSectionList) {
      formSectionList.sort((a, b) => {
        return a.orderNumber - b.orderNumber;
      });

      formSectionList.forEach((formSection) => {
        formSectionRenderList.push(
          <div key={formSection.id} id={formSection.id.toString()}>
            <DisplayFormSection
              key={formSection.id}
              formSection={formSection}
              translate={translate}
              isEditableForm={false}
              allowedFileTypes={""}
              isPortal={false}
            />
            <Divider
              type={"horizontal"}
              style={{ marginTop: 30, marginBottom: 25 }}
            />
          </div>
        );
      });
    }

    return formSectionRenderList;
  };

  const renderTitle = (formVersionId: number) => {
    const formVersion = formVersionList.find(
      (formVersion) => formVersion.id === formVersionId
    );
    return (
      formVersion && (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            paddingBottom: 10,
            marginBottom: 10,
            borderBottomWidth: 1,
            borderBottomColor: "#f0f0f0",
            borderBottomStyle: "solid",
            whiteSpace: "pre-wrap",
            paddingRight: 10,
            paddingLeft: 10
          }}
        >
          <Typography.Title
            type={"secondary"}
            style={{
              fontWeight: "bold",
              fontSize: 16
            }}
          >
            {`${translate("form_details.reporting_period")}:  ${
              formVersion.reportingPeriodName
            }`}
            {"\n"}
            <Text style={{ fontSize: 12 }}>
              {`${translate("form_details.form_type")}: ${
                formVersion.reportingTypeName
              }`}
            </Text>
          </Typography.Title>
          <Typography.Title
            type={"secondary"}
            style={{
              fontWeight: "bold",
              fontSize: 16,
              marginTop: 0
            }}
          >
            {`${translate("compare_versions.version")}: ${
              formVersion.version
            } - ${formVersion.status}`}
            {"\n"}
            <Text style={{ fontSize: 12 }}>
              {formVersion.sendDate
                ? `${translate(
                    "compare_versions.send_date"
                  )}: ${DateService().formatDate(formVersion.sendDate)}`
                : ""}
            </Text>
          </Typography.Title>
        </div>
      )
    );
  };

  return (
    <div
      style={{
        width: "100%",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between"
      }}
    >
      <div style={{ padding: 5, width: "49%" }}>
        {renderTitle(selectedVersions[0])}
        <div style={{ overflowY: "auto", height: HEIGHT_FORM_VERSION }}>
          {renderFormSections(firstComparisonFormVersion || [])}
        </div>
      </div>
      <div style={{ padding: 5, width: "49%" }}>
        {renderTitle(selectedVersions[1])}
        <div style={{ overflowY: "auto", height: HEIGHT_FORM_VERSION }}>
          {renderFormSections(secondComparisonFormVersion || [])}
        </div>
      </div>
    </div>
  );
};

export default ComparisonFormVersions;
